// extracted by mini-css-extract-plugin
export var arrows = "_7b-5";
export var decrementer = "_7b-9";
export var disabled = "_7b-3";
export var error = "_7b-1";
export var hiddenText = "_7b-a";
export var incrementer = "_7b-8";
export var input = "_7b-7";
export var inputWrapper = "_7b-0";
export var leadingIcon = "_7b-b";
export var readonly = "_7b-2";
export var regular = "_7b-6";
export var small = "_7b-4";